import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'

function AppLoader({visibal = false, ...rest}) {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={visibal}
            >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default AppLoader
